"use strict";
// Reusable Stevie Images for tiles
Object.defineProperty(exports, "__esModule", { value: true });
exports.tileSprites = void 0;
var imageRecycler_sidecar_1 = require("@dive/to-engine/imageRecycler-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
exports.tileSprites = imageRecycler_sidecar_1.imageRecycler.create('dungeon-tiles', function () { return voyageLayers_sidecar_1.voyageLayers.getLayers().dungeon; });
